import React, { useState, useEffect, useContext, useRef } from 'react';
import TitleBar from '../components/TitleBar.jsx';
import { urlValue, loadingContext, unfolder, openAlert, closeModalVw, openModalVw, useTranslate, encrypter } from '../lib';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form'
import axios from 'axios';
import '../styles/campaign_customizable.css';
import '../styles/styles.css'
import 'react-multi-carousel/lib/styles.css';
import { Tooltip, } from 'react-tooltip'
import SearchIcon from '../images/search.svg';
import { Alerts } from '../components/common/Alerts';
import Loading from '../components/Loading'
import Button from '../components/provider/button/button.jsx'
import { SelectNesting } from '../components/common/Inputs/Select'
import NewCampaingModal from '../components/NewCampaingModal'
import EditCampaignFullModal from '../components/EditCampaignFullModal'
import NewSubCampaingModal from '../components/NewSubCampaingModal'
import EditSubCampaingModal from '../components/EditSubCampaingModal'
import NewUserStudio from '../components/NewUserStudio'
import SearchUser from '../components/SearchUser';
import DataTable from '../components/provider/datatable/Datatable';
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../components/common/ModalVw'
import Modal from 'react-modal';

const Campaigns = () => {
  const { campaign_id, campaign_name } = useParams();
  const [loading, setLoading] = useContext(loadingContext);
  const [region, setRegion] = useState([])
  const [campaigns, setCampaigns] = useState([])
  const [campaign, setCampaign] = useState('')
  const [subCampaign, setSubCampaign] = useState(null)
  const [lobs, setLobs] = useState([])
  const [alert, setAlert] = useState({ title: '', visible: false });
  const [users, setUsers] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [role, setRole] = useState(0)
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showUserSearch, setShowUserSearch] = useState(false);
  const [selectedUsersList, setSelectedUsersList] = useState([]);
  const [expandedRegions, setExpandedRegions] = useState(new Set());
  const [expandedCampaigns, setExpandedCampaigns] = useState(new Set());
  const [searchCampaigns, setSearchCampaigns] = useState('')
  const [campaings, setCampaings] = useState([])
  const users_ref = useRef(null)
  const lobs_ref = useRef(null)  
  const userSearchResultsRef = React.useRef(null);
  const { t } = useTranslate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  const [isModalCampOpen, setIsModalCampOpen] = useState({
    cam: false,
    campaing: null,
    error: false,
    newCampaing: false,
    drop: false,
    edit: false,
  })
  const [isModalOpen, setIsModalOpen] = useState({
    error: false,
    newCampaing: false,
    newSubCampaing: false,
    drop: false,
    edit: false,
  })
  const [isModalOpenUserStudio, setIsModalOpenUserStudio] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })

  const columnsUsers = [
    {
      header: 'NT User',
      field: 'ccms_name',
      width: '50%',
    },
    {
      header: 'BMS',
      field: 'ccms_id',
      width: '30%',
      align: 'left',
      render: (value) => <div style={{fontSize: 12}}>{value}</div>
    }
    ,{
      header: 'Actions',
      field: 'actions',
      width: '20%',
      align: 'center',
      render: (_, user) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
          <img
            src="/icons/trash.png"
            alt="trash"
            style={{ width: 15, cursor: 'pointer' }}
            onClick={() => openDeleteUserModal(user.id)}
          />
        </div>
      )
    }
  ];

  const [modalDeleteCampaign, setModalDeleteCampaign] = useState({ visible: false, id: null });

  const openDeleteCampaignModal = (campaign_id) => {
    if (!campaign) return;
    setModalDeleteCampaign({ visible: true, id: campaign_id });
  };

  const closeDeleteCampaignModal = () => {
    setModalDeleteCampaign({ visible: false, id: null });
  };

  const deleteCampaign = async () => {
    if (!modalDeleteCampaign.id) return;
    setLoading(true);
    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

      const url = `${urlValue}/studio/campaign/delete/${modalDeleteCampaign.id}`;
      const response = await axios.post(url, {}, {
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
      });

      if (response?.data?.message && response.data.message.toLowerCase().includes('cannot be deleted')) {
        setAlert({ title: response.data.message, visible: true });
      } else if (response?.status === 200) {
        await fetchRegion();
      } else {
        setAlert({ title: t('common.error') + ': ' + (response?.data?.message || 'Unknown error'), visible: true });
      }
      setLoading(false);
      closeDeleteCampaignModal();
    } catch (error) {
      console.error('Error deleting campaign', error);
      setAlert({ title: t('common.error') + ': ' + (error?.response?.data?.message || error.message), visible: true });
      setLoading(false);
      closeDeleteCampaignModal();
    }
  };

  const [modalDeleteUser, setModalDeleteUser] = useState({ visible: false, id: null });

  const openDeleteUserModal = (user_id) => {
    setModalDeleteUser({ visible: true, id: user_id });
  };

  const closeDeleteUserModal = () => {
    setModalDeleteUser({ visible: false, id: null });
  };

  const removeUserFromCampaign = async () => {
    if (!modalDeleteUser.id) return;
    setLoading(true);
    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

      const url = `${urlValue}/studio/campaign/delete/user`;
      const response = await axios({
        method: 'post',
        url,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: {
          ids: modalDeleteUser.id
        }
      });

      if (response?.data?.message && response.data.message.toLowerCase().includes('cannot be deleted')) {
        setAlert({ title: response.data.message, visible: true });
      } else if (response?.status === 200) {
        await getUserLobs(subCampaign);
      } else {
        setAlert({ title: t('common.error') + ': ' + (response?.data?.message || 'Unknown error'), visible: true });
      }
      setLoading(false);
      closeDeleteUserModal();
    } catch (error) {
      console.error('Error removing user from campaign', error);
      setAlert({ title: t('common.error') + ': ' + (error?.response?.data?.message || error.message), visible: true });
      setLoading(false);
      closeDeleteUserModal();
    }
  };

  const [modalDeleSubCamp, setModalDeleSubCamp] = useState({ visible: false, id: null });

  const openDeleteSubCampModal = (lob_id) => {
    setModalDeleSubCamp({ visible: true, id: lob_id });
  };

  const closeDeleteSubCampModal = () => {
    setModalDeleSubCamp({ visible: false, id: null });
  };

  const deleteSubCamp = async () => {
    if (!modalDeleSubCamp.id) return;
    setLoading(true);
    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken;
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

      const url = `${urlValue}/studio/campaign/subcampaign/delete/${modalDeleSubCamp.id}`;
      const response = await axios.post(url, {}, {
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
      });

      if (response?.data?.message && response.data.message.toLowerCase().includes('cannot be deleted')) {
        setAlert({ title: response.data.message, visible: true });
      } else if (response?.status === 200) {
        await getLobs(campaign);
      } else {
        setAlert({ title: t('common.error') + ': ' + (response?.data?.message || 'Unknown error'), visible: true });
      }
      setLoading(false);
      closeDeleteSubCampModal();
    } catch (error) {
      console.error('Error deleting subcampaign', error);
      setAlert({ title: t('common.error') + ': ' + (error?.response?.data?.message || error.message), visible: true });
      setLoading(false);
      closeDeleteSubCampModal();
    }
  };

  const openEditCampaignModal = (campaign_id) => {
    const selected = campaigns.find(c => String(c.id) === String(campaign_id));
    if (selected) {
      openModalVw("#editcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, edit: true, campaing: selected }));
    } else {
      console.warn('No campaign found for id:', campaign_id);
    }
  };
  const closeEditCampaignModal = () => {
    setIsModalCampOpen({ ...isModalCampOpen, edit: false, campaing: null });
  };

  const openEditSubCampaingModal = (lob) => {
    openModalVw("#edit-subcampaing-modal", () => setIsModalOpen({ ...isModalOpen, edit: true, subcampaing: lob }));
  };
  const closeEditSubCampaingModal = () => {
    setIsModalOpen({ ...isModalOpen, edit: false, subcampaing: null });
  };

  const columnsLobs = [
    {
      header: 'Name',
      field: 'name',
      width: '100%',
    },
    {
      header: 'Actions',
      field: 'actions',
      width: '20%',
      align: 'center',
      render: (_, lob) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
          <img
            src="/icons/edit.png"
            alt="edit"
            style={{ width: 15, cursor: 'pointer' }}
            onClick={() => openEditSubCampaingModal(lob)}
          />
          <img
            src="/icons/trash.png"
            alt="trash"
            style={{ width: 15, cursor: 'pointer' }}
            onClick={() => openDeleteSubCampModal(lob.id)}
          />
          <img
            src="/icons/chevron-right.svg"
            alt="chevron"
            style={{ width: 9, cursor: 'pointer' }}
            onClick={() => getUserLobs(lob.id)}
          />
        </div>
      )
    }
  ];

    const handleUserSelect = (user) => {
    setSelectedUsers(prev => {
        if (!prev.some(selectedUser => selectedUser.id === user.id)) {
            return [...prev, user];
        }
        return prev;
    });

    addUserCampaign(user.id)
    
    setShowUserSearch(false);
  };

  const openRegion = (event, regionId) => { 
    setExpandedRegions(prev => {
      const newSet = new Set();
      if (!prev.has(regionId)) {
        newSet.add(regionId);  // solo uno
      }
      return newSet;
    });
  };

  const openCampaing = (event, campaignId) => { 
    if (isModalOpen.edit) return;

    if (
      event.target.closest('.icon-trash') ||
      event.target.closest('img[id^="editc"]')
    ) {
      return;
    }

    setExpandedCampaigns(prev => {
      const newSet = new Set(prev);
      if (newSet.has(campaignId)) {
        newSet.delete(campaignId);
      } else {
        newSet.add(campaignId);
      }
      return newSet;
    });
  };

  const addUserCampaign = user_id => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    axios({
      method: 'post',
      url: `${urlValue}/studio/campaign/adduserscampaign`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        campaing_id: campaign,
        sub_campaing_id: subCampaign,
        user_id: user_id
      },
    })
      .then(function (response) {
        openAlert('#alert-ac', () => { setAlert({ title: t('alerts.accountCreated'), visible: true }) }, 4000,
          () => { setAlert({ ...alert, visible: false }) });
        getUserLobs(subCampaign)
        setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: false })
        setLoading(false)
      })
      .catch(function (error) {
        console.log("error created user studio", error)
        setLoading(false)
      })
  }

  const getUserLobs = async (lob_id) => {
    console.log("Lobs", lob_id)
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setSubCampaign(lob_id)
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/${campaign}/lob/${lob_id}`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        }
      });

      if (rest.status === 200 && rest.data) {
        setUsers(rest.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  useEffect(() => {
    (async () => {
      setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
      await fetchRegion();
      
    })()

  }, []);

  const getCampaigns = async (region_id) => {
    console.log("region", region_id)
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/${id}`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'region_id': region_id
        }
      });

      if (rest.status === 200 && rest.data) {
        setCampaigns(rest.data)
        let selectedId = '';
        if (rest.data.length > 0) {
          selectedId = rest.data[0].id;
        }
        setCampaign(selectedId);
        await getLobs(selectedId);
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const getLobs = async (campaign_id) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/lobs/${campaign_id}`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        }
      });

      if (rest.status === 200 && rest.data) {
        setLobs(rest.data)
        setUsers([])
        setSubCampaign(null)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const selectCampaignRegion = async (region_id) => {
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

    const url = `${urlValue}/studio/campaign/campaignregion/${region_id}`;
    const result = await axios.get(url, {
      headers: {
        user: id,
        'access-token': token,
        'Content-Type': 'application/json',
        'region_id': region_id
      },

    });
    if (result.status === 200 && result.data) {
      setCampaings(result.data)
    }
  }
  
  const fetchRegion = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/regions`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setRegion(rest.data)
        await getCampaigns(rest.data[0].id)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  return (
    <>
  <div className="container-home general-container d-flex flex-row justify-space-center" id="container-home">
        <div className="d-flex flex-column" style={{ flex: 1 }}>
          <TitleBar />

          <div className="title">
            <h1>{t('menu.campaignAccess')}</h1>
          </div>

          <div className='d-flex flex-row flex-wrap justify-content-between mt-2'>
            <div className='tooltip-div'>
              <img id="campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
              <Button 
                label={t('menu.newCampaign')}
                onClick={() => openModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: true }))}
                className='buttonE'
              />
            </div>

            {subCampaign && <div className="d-flex flex-row align-items-center" style={{marginRight: '5px'}}>
              <div className='ml-5 mt-2' style={{marginLeft: '5px', minWidth: 20}}>
                <button 
                    id="add-user-btn"
                    onClick={() => setShowUserSearch(!showUserSearch)} 
                >
                    <img 
                        src={SearchIcon} 
                        style={{width: 20, height: 20, cursor: 'pointer'}} 
                    />
                    <Tooltip anchorSelect="#add-user-btn" content="Search for users to add" place="top" />
                </button>
              </div>
              <div className='tooltip-div' style={{ marginLeft: 12 }}>
                <img id="sub-campaing-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
                <Button 
                  label={t('menu.addUser')}
                  onClick={() => openModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: true }))}
                  className='buttonF' id="btn-sub-campaign"
                >
                  {t('menu.addUser')}
                </Button>
                <Tooltip events={['click']} anchorId="sub-campaing-tp" 
                  html={t('menu.selectCampaign')} place="top" />
              </div>
            </div>}
          </div>

          <div className="d-flex flex-row flex-wrap mt-1" style={{}}>
            <div className='left-home panel-left panel-c ' style={{ overflowY: "hidden", height: "auto", flex: '1 1 auto' }}>
              <div className='list-l-nesting'>
              {region
                  .map((region, i) => {

                    const isExpandedRegion = expandedRegions.has(region.id);

                  return (
                    <div key={`${region.id}-${i}`} className='list-campaing accordion'>
                      <div 
                        onClick={(e) => {
                          selectCampaignRegion(region.id);
                          openRegion(e, region.id);
                        }}
                        className='acordion campaing-name flex items-center'>

                          <div className='d-flex flex-row align-items-center'>{region.name}
                            {/* <img id={"editc" + i} onClick={() => { openModalVw("#campedit-modal", () => setIsModalCampOpen({ ...isModalCampOpen, campaing: camp, edit: true })) }} src="/icons/EditarIcon.svg" style={{ marginLeft: 15, width: 18 }} alt="" /> */}
                          </div>

                          <div className='flex items-center'  >
                            <img 
                              className="icon-arrow" 
                              src="/icons/chevron-right.svg" 
                              alt='' 
                              style={{
                                transform: isExpandedRegion ? 'rotate(270deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                              }}
                            />
                          </div>
                          <Tooltip anchorId={"deletec" + i} content={t('common.delete')} place="top" />

                      </div>
                      <ul className={`list-sub-campaing ${isExpandedRegion ? 'expanded' : 'collapsed'}`}
                        style={{ 
                          maxHeight: isExpandedRegion ? 'none' : '0',
                          overflow: 'hidden',
                          transition: 'max-height 0.3s ease',
                          display: isExpandedRegion ? 'block' : 'none'
                        }}>
                          {campaings?.length > 0 &&
                          (campaings
                            ?.filter(camp => {
                              if (searchCampaigns === '') {
                                return true;
                              } else {
                                const campaignMatch = (camp.campaing_name).toLowerCase().includes(searchCampaigns.toLowerCase());
                                
                                const subCampaignMatch = camp.sub_campaing.some(subcamp => 
                                  (subcamp.sub_campaing_name).toLowerCase().includes(searchCampaigns.toLowerCase())
                                );
                                
                                return campaignMatch || subCampaignMatch;
                              }
                            })
                            ?.map((camp, i) => {

                              const isExpanded = expandedCampaigns.has(camp.id);

                            return (
                              <div key={`${camp.id}-${i}`} className='list-campaing accordion'>
                                <div 
                                  onClick={(e) => {
                                    if (!e.target.closest('.icon-trash') && !e.target.closest('img[id^="editc"]')) {
                                      setCampaign(camp.campaing_id)
                                      openCampaing(e, camp.id);
                                    }
                                  }}  
                                  className='acordion campaing-name flex items-center'>

                                    <div className='d-flex flex-row align-items-center'>{camp.campaing_name}
                                      {/* <img id={"editc" + i} onClick={() => { openModalVw("#campedit-modal", () => setIsModalCampOpen({ ...isModalCampOpen, campaing: camp, edit: true })) }} src="/icons/EditarIcon.svg" style={{ marginLeft: 15, width: 18 }} alt="" /> */}
                                    </div>
                                    {/* <Tooltip anchorId={"editc" + i} content={`Edit`} place="top" /> */}

                                    <div className='flex items-center'  >
                                      <img style={{ marginRight: 10, width: 15, cursor: 'pointer' }} id={"newlob" + i} src="/icons/add-icon-nt.png" alt="new-lob" onClick={() => { setCampaign(camp.campaing_id); openModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: true }))} } />
                                      <Tooltip anchorId={"newlob" + i} content={t('menu.newLOB')} place="top" />
                                      <img style={{ marginRight: 10, width: 15, cursor: 'pointer' }} id={"editCampaign" + i} src="/icons/edit.png" alt="edit" onClick={() => {setCampaign(camp.campaing_id); openEditCampaignModal(camp.campaing_id)}} />
                                      <Tooltip anchorId={"editCampaign" + i} content={t('menu.editCampaign')} place="top" />
                                      <img style={{ marginRight: 10, width: 15, cursor: 'pointer' }} id={"deletec" + i} onClick={() => {setCampaign(camp.campaing_id); openDeleteCampaignModal(camp.campaing_id)}} className="icon-trash" src="/icons/trash-1.png" alt='' />
                                      <Tooltip anchorId={"deletec" + i} content={t('common.delete')} place="top" />
                                      <img 
                                        className="icon-arrow" 
                                        src="/icons/chevron-right.svg" 
                                        alt='' 
                                        style={{
                                          transform: isExpanded ? 'rotate(270deg)' : 'rotate(0deg)',
                                          transition: 'transform 0.3s ease'
                                        }}
                                      />
                                    </div>

                                </div>
                                <ul className={`list-sub-campaing ${isExpanded ? 'expanded' : 'collapsed'}`}
                                  style={{ 
                                    maxHeight: isExpanded ? 'none' : '0',
                                    overflow: 'hidden',
                                    transition: 'max-height 0.3s ease',
                                    display: isExpanded ? 'block' : 'none'
                                  }}>
                                  {camp.sub_campaing.length > 0 && 
                                  camp.sub_campaing
                                    .map((subcamp, index) => {
                                      const matchesSearch = searchCampaigns === '' || 
                                        (subcamp.sub_campaing_name).toLowerCase().includes(searchCampaigns.toLowerCase());
                                      return (
                                        <li key={`${subcamp.sub_campaing_id}-${index}`} onClick={() => getUserLobs(subcamp.sub_campaing_id)}
                                          className='sub-campaing-name flex items-center'
                                          style={{ 
                                            fontWeight: matchesSearch && searchCampaigns !== '' ? 'bold' : 'normal'
                                          }}>
                                          <div className='flex  items-center' style={{ flex: 1 }}>
                                            <span>{subcamp.sub_campaing_name}</span>
                                          </div>
                                          <div className='flex  items-center'  >
                                            <img style={{ marginRight: 10, width: 15, cursor: 'pointer' }} id={"editlob" + i} src="/icons/edit.png" alt="edit" onClick={() => openEditSubCampaingModal(subcamp)} />
                                            <Tooltip anchorId={"editlob" + i} content={t('menu.editSubCampaign')} place="top" />
                                            <img style={{ marginRight: 10 }} id={"deletesc" + i} onClick={() => openDeleteSubCampModal(subcamp.sub_campaing_id)} className="icon-trash" src="/icons/trash-1.png" alt='' />
                                            <Tooltip anchorId={"deletesc" + i} content={t('common.delete')} place="top" />
                                            <img id={"content" + i}  style={{ marginLeft: 5, width: 9, transform: "rotate(0deg)" }} className="icon-arrow" src="/icons/chevron-right.svg" alt='' />
                                          </div>
                                        </li>
                                      )
                                    }
                                  )}
                                </ul>
                              </div>
                              )
                          }))}
                      </ul>
                    </div>
                    )
                })}
              </div>
            </div>
            <div className='rigth-home panel-c' style={{ overflowY: "hidden", overflowX: 'clip', height: "auto", flex: '1 1 auto' }}>
              {subCampaign && 
              <div id="project-all  " className='list-r-nesting'>
                <div className="d-flex flex-row align-items-center justify-space-between " style={{ marginBottom: 15 }}>
                  
                </div>
                <div id="user-search-results" ref={userSearchResultsRef} className="px-3 mb-3">
                  <SearchUser 
                      onUserSelect={handleUserSelect}
                      searchResultsContainer={userSearchResultsRef.current}
                      showSearch={showUserSearch}
                      setShowSearch={setShowUserSearch}
                      filterSource={'studio'}
                  />
                </div>
                <DataTable
                    columns={columnsUsers}
                    data={users}
                    tableRef={users_ref}
                    tableId="usersCampaign-all"
                    keyField="id"
                    emptyMessage={t('menu.usersNotFound')}
                    tableStyles={{ 
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}
                    headerStyles={{
                      backgroundColor: '#f5f5f5',
                      fontWeight: 'bold',
                      fontSize: '14px'
                    }}
                    rowStyles={{
                      transition: 'background-color 0.2s'
                    }}
                  />
              </div>}
            </div>

          </div>
        </div>
        {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
        <Modal
          isOpen={modalDeleteCampaign.visible}
          style={{
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.35)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
            content: {
              position: 'relative',
              maxWidth: 380,
              width: '90%',
              margin: 'auto',
              borderRadius: 16,
              padding: '32px 24px 24px 24px',
              background: '#fff',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              border: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }
          }}
          ariaHideApp={false}
        >
          <div id="container-modal" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
            <img src="/icons/alert.png" alt='' style={{ width: 48, height: 48, marginBottom: 8 }} />
            <h1 style={{ fontSize: 20, fontWeight: 700, color: '#E53935', textAlign: 'center', margin: 0 }}>{t('menu.deleteCampaignModal') || 'Eliminar campaña'}</h1>
            <h2 style={{ fontSize: 16, fontWeight: 400, color: '#333', textAlign: 'center', margin: '8px 0 0 0' }}>{t('menu.deleteConfirmQuestion') || '¿Está seguro que desea eliminar la campaña?'}</h2>
            <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
              <button
                onClick={closeDeleteCampaignModal}
                style={{
                  padding: '8px 24px',
                  borderRadius: 8,
                  border: '1px solid #ccc',
                  background: '#f5f5f5',
                  color: '#333',
                  fontWeight: 500,
                  cursor: 'pointer',
                  minWidth: 100
                }}
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={deleteCampaign}
                style={{
                  padding: '8px 24px',
                  borderRadius: 8,
                  border: 'none',
                  background: '#0B5FA3',
                  color: '#fff',
                  fontWeight: 600,
                  cursor: 'pointer',
                  minWidth: 100
                }}
              >
                {t('common.accept')}
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={modalDeleteUser.visible}
          style={{
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.35)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
            content: {
              position: 'relative',
              maxWidth: 380,
              width: '90%',
              margin: 'auto',
              borderRadius: 16,
              padding: '32px 24px 24px 24px',
              background: '#fff',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              border: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }
          }}
          ariaHideApp={false}
        >
          <div id="container-modal" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
            <img src="/icons/alert.png" alt='' style={{ width: 48, height: 48, marginBottom: 8 }} />
            <h1 style={{ fontSize: 20, fontWeight: 700, color: '#E53935', textAlign: 'center', margin: 0 }}>{t('menu.deleteUserModal')}</h1>
            <h2 style={{ fontSize: 16, fontWeight: 400, color: '#333', textAlign: 'center', margin: '8px 0 0 0' }}>{t('menu.deleteConfirmQuestion')}</h2>
            <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
              <button
                onClick={closeDeleteUserModal}
                style={{
                  padding: '8px 24px',
                  borderRadius: 8,
                  border: '1px solid #ccc',
                  background: '#f5f5f5',
                  color: '#333',
                  fontWeight: 500,
                  cursor: 'pointer',
                  minWidth: 100
                }}
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={removeUserFromCampaign}
                style={{
                  padding: '8px 24px',
                  borderRadius: 8,
                  border: 'none',
                  background: '#0B5FA3',
                  color: '#fff',
                  fontWeight: 600,
                  cursor: 'pointer',
                  minWidth: 100
                }}
              >
                {t('common.accept')}
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={modalDeleSubCamp.visible}
          style={{
            overlay: {
              backgroundColor: 'rgba(0,0,0,0.35)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
            content: {
              position: 'relative',
              maxWidth: 380,
              width: '90%',
              margin: 'auto',
              borderRadius: 16,
              padding: '32px 24px 24px 24px',
              background: '#fff',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              border: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }
          }}
          ariaHideApp={false}
        >
          <div id="container-modal" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
            <img src="/icons/alert.png" alt='' style={{ width: 48, height: 48, marginBottom: 8 }} />
            <h1 style={{ fontSize: 20, fontWeight: 700, color: '#E53935', textAlign: 'center', margin: 0 }}>{t('menu.deleteSubCampaignModal')}</h1>
            <h2 style={{ fontSize: 16, fontWeight: 400, color: '#333', textAlign: 'center', margin: '8px 0 0 0' }}>{t('menu.deleteConfirmQuestion')}</h2>
            <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
              <button
                onClick={closeDeleteSubCampModal}
                style={{
                  padding: '8px 24px',
                  borderRadius: 8,
                  border: '1px solid #ccc',
                  background: '#f5f5f5',
                  color: '#333',
                  fontWeight: 500,
                  cursor: 'pointer',
                  minWidth: 100
                }}
              >
                {t('common.cancel')}
              </button>
              <button
                onClick={deleteSubCamp}
                style={{
                  padding: '8px 24px',
                  borderRadius: 8,
                  border: 'none',
                  background: '#0B5FA3',
                  color: '#fff',
                  fontWeight: 600,
                  cursor: 'pointer',
                  minWidth: 100
                }}
              >
                {t('common.accept')}
              </button>
            </div>
          </div>
        </Modal>
      </div>

      {isModalCampOpen.edit && (
        <ModalVw id="editcp-modal" visible={isModalCampOpen.edit}>
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} onClose={() => closeModalVw("#editcp-modal", closeEditCampaignModal)} />
            <ModalBody clases={``} >
              <EditCampaignFullModal
                isModalOpen={{ edit: true, campaing: isModalCampOpen.campaing }}
                closeModal={() => closeModalVw("#editcp-modal", closeEditCampaignModal)}
                campaign_id={isModalCampOpen.campaing?.id}
                editTexts={{
                  title: t('menu.editCampaign'),
                  button: t('common.edit')
                }}
              />
            </ModalBody>
          </ModalContent>
        </ModalVw>
      )}

      {isModalCampOpen.cam &&
      <ModalVw id="newcp-modal" visible={isModalCampOpen.cam}  >
        <ModalContent clases={`bg-white`}>
          <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: false }))} />
          <ModalBody clases={``} >
            <NewCampaingModal isModalOpen={isModalCampOpen} closeModal={() => closeModalVw("#newcp-modal", () => setIsModalCampOpen({ ...isModalCampOpen, cam: false }))} />
          </ModalBody>
        </ModalContent>
      </ModalVw>}

      {isModalOpen.newSubCampaing &&
        <ModalVw id="sbnewcp-modal" visible={isModalOpen.newSubCampaing}  >
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} title="" onClose={() => closeModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: false }))} />
            <ModalBody clases={``} >
              <NewSubCampaingModal campaign_id={campaign} isModalOpen={isModalOpen} closeModal={() => { closeModalVw("#sbnewcp-modal", () => setIsModalOpen({ ...isModalOpen, newSubCampaing: false })) }} />
            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {isModalOpen.edit &&
        <ModalVw id="edit-subcampaing-modal" visible={isModalOpen.edit}>
          <ModalContent clases={`bg-white`}>
            <ModalHeader iconClose={true} onClose={closeEditSubCampaingModal} />
            <ModalBody clases={``} >
              <EditSubCampaingModal
                isModalOpen={{ edit: true, subcampaing: isModalOpen.subcampaing }}
                closeModal={closeEditSubCampaingModal}
                campaign_id={campaign}
                editTexts={{
                  title: t('menu.editSubCampaign'),
                  button: t('common.edit')
                }}
              />
            </ModalBody>
          </ModalContent>
        </ModalVw>}

        {isModalOpenUserStudio.new &&
          <ModalVw id="adduser-studio" visible={isModalOpenUserStudio.new} className="z-[500]">
            <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
              <ModalHeader title="" onClose={() => closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: false }))} />
              <ModalBody clases={``} >
                <NewUserStudio isModalOpen={isModalOpenUserStudio} 
                  closeModal={() => { closeModalVw("#adduser-studio", () => setIsModalOpenUserStudio({ ...isModalOpenUserStudio, new: false })) }} 
                  associateToProject={false}
                  isCampaign={true}
                  closeFunction={(user_id) => {
                    addUserCampaign(user_id)
                  }}
                />
              </ModalBody>
            </ModalContent>
        </ModalVw>
        }
     
    </>
  );
};

export default Campaigns;
